import Component from "./notifications.component";
import { Config } from "./notifications.config";

export default { Component, config: Config };
